var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 8 8"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M.167.167a.571.571 0 0 1 .808 0L4 3.192 7.025.167a.571.571 0 1 1 .808.808L4.808 4l3.025 3.025a.571.571 0 1 1-.808.808L4 4.808.975 7.833a.571.571 0 1 1-.808-.808L3.192 4 .167.975a.571.571 0 0 1 0-.808Z",
  clipRule: "evenodd"
})));
export default SvgClose;